// @flow
import React, { useCallback } from 'react';
import Modal from 'app/common/components/Modal';
import { ButtonsBar } from 'app/common/ui/Button';
import { useTranslation } from 'react-i18next';

import styles from './ExOrderSelectActions.module.scss';;


type Props = {
  loading: boolean,
  onDelete: (void) => Promise<void>,
  onClose: (void) => void,
  needChoice: boolean,
  setNeedChoice: (boolean) => void,
}

const ExOrderSelectActions = ({
  loading,
  onDelete,
  onClose,
  needChoice,
  setNeedChoice,
}: Props) => {
  const { t } = useTranslation('cafeteria');

  const handleDelete = useCallback(async (e: SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    const res = await onDelete();
    if (res) {
      setNeedChoice(false);
    }
  }, [onDelete, setNeedChoice]);

  const handleEdit = useCallback((e: SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    setNeedChoice(false);
  }, [setNeedChoice]);

  const handleCancel = useCallback((e: SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    onClose();
    setNeedChoice(false);
  }, [onClose, setNeedChoice]);


  return (
    <Modal isOpen={needChoice}>
      <h2 className={styles.header}>
        {t('order_form_create_order_header', 'Создание заказа')}
      </h2>
      <div className={styles.text}>
        {t('order_form_create_order_conflict', 'Имеется невыполненный заказ. Что хотите сделать?')}
      </div>
      <ButtonsBar
        className={styles.buttons}
        middle={[{
          key: 'delete',
          value: t('order_form_delete_and_create', 'Удалить и создать новый'),
          onClick: handleDelete,
          error: true,
          disabled: loading,
        }, {
          key: 'edit',
          value: t('order_form_edit_bt', 'Редактировать'),
          onClick: handleEdit,
          disabled: loading,
        }, {
          key: 'cancel',
          value: t('order_form_cancel_bt', 'Отмена'),
          outline: true,
          onClick: handleCancel,
        }]}
      />
    </Modal>
  );
};

export default ExOrderSelectActions;
